import { AgGridModule } from 'ag-grid-angular';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { AccountInfoModule } from '../account-info-header/account-info.module';
import { CreateRequestModule } from '../create-request/create-request.module';
import { SharedModule } from '../shared/shared.module';
import { TransactionViewModule } from '../transaction-view/transaction-view.module';
import { StandingAuthorizationDetailsCheckComponent } from './components/sa-details-check/sa-details-check.component';
import { StandingAuthorizationDetailsInternalTransfersComponent } from './components/sa-details-internal-transfers/sa-details-internal-transfers.component';
import { StandingAuthorizationsFormComponent } from './components/standing-authorizations-form/standing-authorizations-form.component';
import { StandingAuthorizationsInputPageComponent } from './components/standing-authorizations-input-page/standing-authorizations-input-page.component';
import { StandingAuthorizationsComponent } from './container/standing-authorizations.component';
import * as fromStandingAuthorizationState from './reducers';
import { StandingAuthorizationDetailsWireComponent } from './components/sa-details-wire/sa-details-wire.component';
import { SaReviewPageComponent } from './components/sa-review-page/sa-review-page.component';
import { SaTransactionReviewComponent } from './components/sa-transaction-review/sa-transaction-review.component';
import { SaTransactionDetailsSectionItComponent } from './components/sa-transaction-details-section-it/sa-transaction-details-section-it.component';
import { SaTransactionDetailsSectionCheckComponent } from './components/sa-transaction-details-section-check/sa-transaction-details-section-check.component';
import { AuthorizationNicknameComponent } from './components/authorization-nickname/authorization-nickname.component';
import { WireAuthorizationNicknameComponent } from './components/wire-authorization-nickname/wire-authorization-nickname.component';
import { SaWireTaxWithholdingsComponent } from './components/sa-wire-tax-withholdings/sa-wire-tax-withholdings.component';
import { SaTransactionDetailsSectionWireComponent } from './components/sa-transaction-details-section-wire/sa-transaction-details-section-wire.component';
import { SaConfirmationPageComponent } from './components/sa-confirmation-page/sa-confirmation-page.component';
import { SaConfirmationDetailsSectionComponent } from './components/sa-confirmation-details-section/sa-confirmation-details-section.component';
import { SaCheckTaxWithholdingsComponent } from './components/sa-check-tax-withholdings/sa-check-tax-withholdings.component'
import { SaItTaxWithholdingsComponent } from './components/sa-it-tax-withholdings/sa-it-tax-withholdings.component'
import { SaAchContributionReasonComponent } from './components/sa-ach-contribution-reason/sa-ach-contribution-reason.component';
import { SaAchExtraPromptsComponent } from './components/sa-ach-extra-prompts/sa-ach-extra-prompts.component';
import { SaAchSourceOfFundsComponent } from './components/sa-ach-source-of-funds/sa-ach-source-of-funds.component';
import { SaAchTransferDirectionComponent } from './components/sa-ach-transfer-direction/sa-ach-transfer-direction.component';
import { StandingAuthorizationAchComponent } from './components/sa-details-ach/sa-details-ach.component';
import { SATransactionDetailsSectionAchComponent } from './components/sa-transaction-details-section-ach/sa-transaction-details-section-ach.component';
import { SaAchTaxWithholdingsComponent } from './components/sa-ach-tax-withholdings/sa-ach-tax-withholdings.component';
import { SaBundledToggleComponent } from './components/sa-bundled-toggle/sa-bundled-toggle-component';
import { SaTransactionDetailsSectionWireIsoComponent } from './components/sa-transaction-details-section-wire-iso/sa-transaction-details-section-wire-iso.component';
import { SwitchModule } from '@charlesschwab/as-ui-core';
import { SaMasterStatusViewComponent } from './components/sa-master-status-view/sa-master-status-view.component';
import { SaMasterStatusTableComponent } from './components/sa-master-status-table/sa-master-status-table.component';

const COMPONENTS = [
  StandingAuthorizationsComponent,
  StandingAuthorizationsInputPageComponent,
  StandingAuthorizationsFormComponent,
  StandingAuthorizationDetailsWireComponent,
  StandingAuthorizationDetailsInternalTransfersComponent,
  StandingAuthorizationDetailsCheckComponent,
  AuthorizationNicknameComponent,
  WireAuthorizationNicknameComponent,
  SaReviewPageComponent,
  SaTransactionReviewComponent,
  SaItTaxWithholdingsComponent,
  SaTransactionDetailsSectionItComponent,
  SaTransactionDetailsSectionCheckComponent,
  SaWireTaxWithholdingsComponent,
  SaTransactionDetailsSectionWireComponent,
  SaTransactionDetailsSectionWireIsoComponent,
  SATransactionDetailsSectionAchComponent,
  SaConfirmationPageComponent,
  SaConfirmationDetailsSectionComponent,
  SaCheckTaxWithholdingsComponent,
  SaAchExtraPromptsComponent,
  SaAchTransferDirectionComponent,
  SaAchSourceOfFundsComponent,
  SaAchContributionReasonComponent,
  StandingAuthorizationAchComponent,
  SaAchTaxWithholdingsComponent,
  SaBundledToggleComponent,
  SaMasterStatusViewComponent,
  SaMasterStatusTableComponent
]

@NgModule({
  declarations: [
    COMPONENTS
  ],
  imports: [
    CommonModule,
    SharedModule,
    AccountInfoModule,
    SwitchModule,
    CreateRequestModule,
    AgGridModule,
    TransactionViewModule,
    ReactiveFormsModule,
    StoreModule.forFeature(
      fromStandingAuthorizationState.standingAuthFeatureKey,
      fromStandingAuthorizationState.reducers
    )
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [COMPONENTS],
})
export class StandingAuthorizationsModule { }
